module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAsUlEQVQoU2Pkl9MV/M3AoPTt0eWzDHgAl5yuMSsDwz1GThndcgYGxnJGpv+uuDSBFP//x7ibgeF/JyPIUA4Z/ZmMDP9DsWmCKf7PwLj6x5OL6WANuDShKwapg2tA1wTig5wBMxlmMIoGZE1gDVBnIIcFhgaoM86ArWf6b4IeECgakN0McS9mQMA1YPMgttADa8CmGFfoMeJTjE0TI5e0bto/RiZjUKTgSxog5zH9/3cWABvphoE02i+5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-close.png
// module id = p6I1
// module chunks = 0